import React, { FunctionComponent, useCallback, useState } from 'react';
import SectionStatesWrapper, {
  ISectionStatesProps,
} from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import FeatureCategoryList from '../../featureCategories/featureCategoryList/FeatureCategoryList';
import ISection from '../../../../../model/ISection';
import FeatureAccessoryDetailsModal from '../../features/featureAccessory/featureAccessoryDetailsModal/FeatureAccessoryDetailsModal';
import IFeature from '../../../../../model/IFeature';
import FeatureCategoryLayoutDisplay from '../../featureCategories/FeatureCategoryLayoutDisplay';
import CustomiseOptionsTotal from '../../simpleBrands/customiseOptions/customiseOptionsTotal/CustomiseOptionsTotal';
import availableFeaturesService from '../../../../../service/availableFeaturesService';
import { useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';
import useSalesEnablementContext from '../../../../../../gqlCommon/hooks/useSalesEnablementContext';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

export interface IFeatureSectionDetailsProps extends ISectionStatesProps {
  section: ISection;
  loading: boolean;
}

const FeatureSectionDetails: FunctionComponent<IFeatureSectionDetailsProps> = ({ section, loading, error }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState<IFeature>(null);
  const { isInSalesEnablement } = useSalesEnablementContext();
  const { optimisticSelectedFeatures } = useCustomizeCarContext();

  const availableCategories = !isInSalesEnablement
    ? section.categories
        .map(category => ({
          ...category,
          featuresList: {
            ...category.featuresList,
            features: category.featuresList.features.filter(feature => !feature.attributes.salespersonViewOnly),
          },
        }))
        .filter(category => category.featuresList.features.length > 0)
    : section.categories;

  const featuresTotalCount = availableFeaturesService.getFeaturesTotalCount(availableCategories);
  const {
    spc: {
      customise: { displayFeaturesTotal },
    },
  } = useTheme<ISpcTheme>();

  const openFeatureAccessoryDetailsModal = useCallback((value: boolean, feature: IFeature) => {
    setModalOpen(value);
    setSelectedFeature(feature);
  }, []);

  return (
    <SectionStatesWrapper error={error} loading={loading || !section}>
      {!!featuresTotalCount && displayFeaturesTotal && (
        <CustomiseOptionsTotal optionsTotal={featuresTotalCount} code={section?.code} />
      )}
      <FeatureCategoryList
        categories={section.categories}
        openAccessoryDetailsModal={openFeatureAccessoryDetailsModal}
      />
      {!!section.featuresList.features.length && (
        <FeatureCategoryLayoutDisplay
          openAccessoryDetailsModal={openFeatureAccessoryDetailsModal}
          featuresList={section.featuresList}
          categoryAttributes={section.attributes}
        />
      )}
      <FeatureAccessoryDetailsModal
        feature={selectedFeature}
        isSelected={optimisticSelectedFeatures?.includes(selectedFeature?.code)}
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      />
    </SectionStatesWrapper>
  );
};

export default FeatureSectionDetails;
